const provinces = [
    { value: "PE", text: "Prince Edward Island" },
    { value: "NB", text: "New Brunswick" },
    { value: "NS", text: "Nova Scotia" },
    { value: "NL", text: "Newfoundland & Laborador" },
    { value: "QC", text: "Quebec" },
    { value: "ON", text: "Ontario" },
    { value: "MB", text: "Manitoba" },
    { value: "SK", text: "Saskatchewan" },
    { value: "AB", text: "Alberta" },
    { value: "BC", text: "British Columbia" },
    { value: "YT", text: "Yukon" },
    { value: "NW", text: "Northwest Terrirories" },
    { value: "NU", text: "Nunavut" }
];

const states = [{ value: "WA", text: "Washington" }];

export default {
    provinces,
    states
}